<template>
  <div class="product-form product-form--basic-info row">
    <div class="col-24">
      <div class="product-form__input-wrap">
        <div class="product-form__title">Czy content ma być widoczny?</div>
        <label
            :for="'check-have_content-' + product.id"
            class="product-form__checkbox"
        >
          <input
              :id="'check-have_content-' + product.id"
              class="product-form__checkbox--input"
              type="checkbox"
              v-model="product.have_content"
              @change="$root.$emit('productIsChanged')"
          />
          <span
              class="product-form__checkbox-checkmark"
              v-text="product.have_content ? 'Tak' : 'Nie'"
          ></span>
        </label>
      </div>
      <draggable v-model="product.contents" @change="changeOrder">
        <div v-for="(content, index) in product.contents" :key="content.id">
          <WooContentItem
            :content="content"
            :index="index"
            :dictionaries="dictionaries"
            @deleteContent="deleteContent"
          ></WooContentItem>
        </div>
      </draggable>

      <button
        class="button button--icon"
        @click="addContent(), $root.$emit('productIsChanged')"
      >
        <icon
          icon="plus"
          icon-classes="button__icon button__icon--left icon--white icon__plus--small"
        />
        <span class="button__text">Dodaj nowy opis</span>
      </button>
    </div>
  </div>
</template>
<script>
import Icon from "../parts/Icon";
import draggable from "vuedraggable";
import WooContentItem from "./WooContentItem.vue";

export default {
  data() {
    return {};
  },
  props: {
    product: {
      type: Object,
      required: false,
    },
    dictionaries: {
      type: Object,
      required: false,
    },
  },
  components: {
    Icon,
    draggable,
    WooContentItem,
  },
  methods: {
    changeOrder() {
      this.product.contents.forEach((content, index) => {
        content["order"] = index + 1;
      });
    },
    addContent() {
      var content = {
        id: null,
        title: null,
        subtitle: null,
        description: null,
        product_content_option_id: null,
        photo: {
          id: null,
          path: null,
        },
        order: this.product.contents.length + 1,
      };
      this.product.contents.push(content);
    },
    deleteContent(index) {
      this.product.contents.splice(index, 1);
      this.changeOrder();
    },
  },
};
</script>
